import { Input } from "antd";
import React from "react";
import { i18n } from "~/i18n.js";

export const MoneyInput = ({
  id = "",
  value = "",
  onChange = (e) => {},
  ...rest
}) => {
  return (
    <Input
      addonBefore={i18n.currencySymbol}
      type="number"
      step={1}
      value={value}
      style={{ maxWidth: 150 }}
      onChange={onChange}
      {...rest}
    />
  );
};
